<script>
import { SDK_IDS, CONSTANT } from '@/utils/constant'
import { mapGetters } from 'vuex'
import orchestration from '../../../../orchestration'
import { EventBus } from '@/event-bus'
import toasterService from '@/utils/toaster'
import messages from '@/messages'

export default {
  name: 'SdkSelection',

  data () {
    return {
      sdkNetworks: [],
      SDKIds: SDK_IDS
    }
  },

  computed: {
    ...mapGetters(['loadedSDKs'])
  },

  methods: {

    toggleBrands (sdkId, event) {
      let sdkNetworkIndex = this.loadedSDKs.indexOf(sdkId)
      if (event.target.checked && sdkNetworkIndex === -1) {
        this.loadedSDKs.push(sdkId)
      } else if (sdkNetworkIndex !== -1) {
        this.loadedSDKs.splice(sdkNetworkIndex, 1)
      }

      if (this.loadedSDKs.length === 0) {
        toasterService.onFailure(messages['en-US'].errorMessages.NO_SDK_NETWORK)
      } else {
        this.bootstrapSdkOnNetworkChange()
      }
    },

    bootstrapSdkOnNetworkChange () {
      this.$store.commit('loaderOn', true)
      this.$store.commit('loadedSDKs', this.loadedSDKs)
      this.$store.commit('changeAllSdkLoaded', false)
      orchestration.callMethod({ methodName: CONSTANT.TRACE.METHOD.BOOTSTRAP }).then(() => {
        setTimeout(() => {
          this.$store.dispatch('updateAllSdkLoaded', true).then(() => {
            this.$store.commit('loaderOn', false)
            EventBus.$emit('changeConfiguration')
            EventBus.$emit('refreshSrcId')
          })
        }, 1000)
      })
    }

  }
}
</script>
<template>
  <div id="loaded-sdk-selection">
    <div class="card mb-4">
      <h5
        aria-controls="loadedSdksSelection"
        aria-expanded="true"
        class="card-header collapsed cursor-pointer"
        data-target="#loadedSdksSelection"
        data-toggle="collapse"
      >
        <span class="font-weight-bold">Select SDK Networks</span>
        <span class="collapsible-arrow pull-right cursor-pointer" />
      </h5>
      <div
        id="loadedSdksSelection"
        class="card-body collapse"
      >
        <div class="form-group row">
          <label class="col-sm-3">SDK Networks</label>

          <div class="col-sm-9">
            <div
              v-for="sdkId in SDKIds"
              :key="sdkId"
              class="form-check form-check-inline"
            >
              <input
                :id="'sdkNetwork' + sdkId"
                :checked="loadedSDKs.includes(sdkId)"
                :data-test="'sdkNetwork-' + sdkId"
                class="form-check-input"
                type="checkbox"
                @click="toggleBrands(sdkId, $event)"
              >
              <label
                :for="'sdkNetwork' + sdkId"
                class="form-check-label text-capitalize">{{ sdkId }}
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
